import { render, staticRenderFns } from "./RemoveRole.vue?vue&type=template&id=653833c4&scoped=true&"
import script from "./RemoveRole.vue?vue&type=script&lang=js&"
export * from "./RemoveRole.vue?vue&type=script&lang=js&"
import style0 from "./RemoveRole.vue?vue&type=style&index=0&id=653833c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653833c4",
  null
  
)

export default component.exports